import React from "react";
import { Route, Redirect } from "react-router-dom";
import StorageService from '../../services/StorageService';
import { CLINICAL_ADMIN } from '../../constants/roles';
import { ChosenPatientContext } from '../../pages/Dashboard/tableContext';
import { USER, SESSION } from '../../constants/storageConstants';
import { FALLBACK_ROUTE } from "../../constants/routes";

const storageService = new StorageService();

function PrivateRoute({ layout: Layout, component: Component, roles= [], ...rest }) {
    const isTokenActual = storageService.getValueByKey(SESSION);
    const role = storageService.getValueByKey(USER)?.role;
    const isUserClinicalAdmin = role === CLINICAL_ADMIN;

    if (!isTokenActual && !isUserClinicalAdmin) {
        storageService.deleteValueByKey(SESSION);
        storageService.deleteValueByKey(USER);
        return (
            <Redirect to="/login" />
        );
    }

    if (roles.length && !roles.includes(role)) {
        return <Redirect to={FALLBACK_ROUTE} />;
    }

    return <Route {...rest} render={(props) => (
        <Layout>
            <ChosenPatientContext.Provider >
                <Component {...props} />
            </ChosenPatientContext.Provider>
        </Layout>
    )} />;
}

export default PrivateRoute;
